<header *ngIf="{ tenantId: currentTenantId$ | async, auth: authenticated$ | async } as params">
  <div class="logo_area">
    <button mat-icon-button [routerLink]="[params.tenantId, 'home']" routerLinkActive="active">
      <img src="assets/nav/header_logo_new.png" />
    </button>
  </div>

  <div id="e2e_patient_tabs" class="patient_tabs">
    <button id="e2e_home_button" mat-button class="home_icon"
      [routerLink]="[params.tenantId, 'home']" routerLinkActive="active">
      <mat-icon>home</mat-icon>
    </button>

    <ng-container *ngVar="currentRoutedPatient$ | async as routedPatient">
      <button mat-button class="patient_tab" *ngFor="let patient of activePatients$ | async"
        (click)="!patient.loading && selectPatientTab(patient.patientId)"
        [class.active]="patient.patientId === routedPatient"
        [disabled]="patient.loading">
        <ng-container *ngIf="!patient.loading; else loadingTab">
          <div class="patient_name">
            <!-- Dev note: Locator class -->
            <span class="loc-tab-patient-name">{{ patient.patientName | titlecase }}</span>
            <!-- Dev note: Locator class -->
            <mat-icon class="recording-icon" *ngIf="isRecordingAndNotPaused$(patient.patientId) | async">
              radio_button_checked </mat-icon>
            <mat-icon class="paused-icon" *ngIf="isRecordingAndPaused$(patient.patientId) | async">
              pause_circle_filled </mat-icon>
            <mat-icon class="loc-tab-patient-close"
              [ngClass]="{ 'orange-border': inProgressEncounter(params.tenantId, patient.patientId) }"
              routerLinkActive="active"
              (click)="$event.stopPropagation(); removeActivePatient(params.tenantId, patient.patientId)">cancel</mat-icon>
          </div>
        </ng-container>
        <ng-template #loadingTab>
          <div class="patient_tab__skeleton"></div>
        </ng-template>
      </button>
    </ng-container>
  </div>

  <div class="header_search">
    <input id="e2e_patient_search_box" type="text" #searchInput placeholder="Patient search"
      [formControl]="searchControl" [matAutocomplete]="auto" class="search_box"
      (keydown.escape)="searchInput.blur()" />

    <button id="e2e_patient_search_button" mat-button (click)="focusSearchInput()">
      <mat-icon class="searchIcon" fontSet="material-icons-outlined">search</mat-icon>
    </button>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPatient($event.option.value)">
      <mat-option *ngFor="let patient of filteredPatients$ | async" [value]="patient.PatientId"
        class="header-search-result">
        <span class="text">
          {{ patient.PatientDetails.FirstName }} {{ patient.KnownAs && '(' + patient.KnownAs + ')'
          }} {{ patient.PatientDetails.Surname }} -
          {{ patient.PatientDetails.DateOfBirth | date : 'mediumDate' }} -
          {{ (!patient.PatientAccountDetails.IsCashAccount ?
          patient.PatientAccountDetails.MedicalAidName : null) || 'CASH' }}
        </span>
        <mat-icon matTooltip="Add patient to waiting room"
          (click)="$event.stopPropagation(); addToWaitingRoom(patient.PatientId, params.tenantId)">add</mat-icon>
      </mat-option>
    </mat-autocomplete>
    <mat-icon *ngxPermissionsExcept="[VITALS_ONLY_PERMISSION.DenyViewAddPatient]"
      class="addIcon clickable" fontSet="material-icons-outlined"
      [routerLink]="[params.tenantId, 'patient', 'add']">
      person_add
    </mat-icon>
  </div>

  <div class="doctor_bio">
    <div class="doctor_name">
      <a [routerLink]="[params.tenantId, 'provider']">
        <h4 class="doctor-name-title">{{ (currentProvider$ | async)?.TreatingDoctorName }}</h4>
      </a>
    </div>
    <!-- <div class="doctor_avatar">
      <img src="/assets/images/drstrange.png" alt="{{ (currentProvider$ | async)?.TreatingDoctorName }}" />
    </div> -->
  </div>
</header>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="displayProgressBar$ | async">
</mat-progress-bar>